import React from "react";
import { BookingRequirement } from "../../../../../../types/VenueGroup";
import {
  EditableFieldSwitch,
  ReadOnlyField
} from "../../../../../blocks/form-fields";
import { RequirementValue } from "../../../../../../utils/bookingRequirements";

interface RequirementFieldProps {
  requirement: BookingRequirement;
  value: RequirementValue;
  canEdit: boolean;
  onChange: (name: string, value: RequirementValue) => void;
}

export const RequirementField = React.memo(function RequirementField({
  requirement,
  value,
  canEdit,
  onChange
}: RequirementFieldProps) {
  if (!canEdit) {
    return (
      <ReadOnlyField
        label={requirement.label}
        value={value}
        type={requirement.type}
        options={requirement.options}
      />
    );
  }

  return (
    <EditableFieldSwitch
      fieldId={`requirement-${requirement.name}`}
      type={requirement.type}
      label={requirement.label}
      value={value}
      options={requirement.options}
      onChange={(newValue) => onChange(requirement.name, newValue)}
      fallback={
        <ReadOnlyField
          label={requirement.label}
          value={value}
          type={requirement.type}
          options={requirement.options}
        />
      }
    />
  );
});
